import angular from 'angular';
import ResourcesModule from '../../resources/resources';
import template from './segmentsPreview.jade';

export class SegmentsPreviewController {
  /* @ngInject */
  constructor($scope) {
    this.title = this.title || ' Segment preview';

    this.$onInit = () => {
      this.segment.preview.stringifiedTopCountries = '-';
      this.segment.preview.stringifiedTopDevices = '-';
    };
  }

  get new() { return !this.segment.id; }

  isAllDataThere() {
    return !!((this.segment.preview.sizeAlreadyLoadedOnce || !this.segment.preview.loading.size || this.segment.newAndPristine) && this.segment.preview.total_size >= 0 && this.segment.preview.segment_size >= 0);
  }
}

export let SegmentsPreviewComponent = {
  template: () => { return template },
  controller: SegmentsPreviewController,
  controllerAs: 'vm',
  bindings: {
    segment: '=',
    hideDevices: '@',
    hideCountries: '@',
    title: '@'
  }
};

export default angular.module('app.components.segments.preview', [
  ResourcesModule.name
])
.component('segmentsPreview', SegmentsPreviewComponent);



/** WEBPACK FOOTER **
 ** ./src/components/segments/segmentsPreview.js
 **/